import { Css } from "@homebound/beam";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { WorkflowStep } from "src/routes/projects/change-events/guided/workflows/types";

// Placeholder shown for steps that aren't built yet.
function NotInPrototypeYet() {
  return <div css={Css.sm.gray700.$}>This step is not part of the prototype yet.</div>;
}

// Downstream steps common to every workflow. Generic factories so `F` is inferred from the
// workflow's `steps` array they are spread into (`ObjectState<F>` is invariant in `F`, so a
// single shared constant can't be assigned across different form shapes). They don't read the
// form and are disabled for now since they aren't implemented.
export function reviewImpactStep<F>(): WorkflowStep<F> {
  return {
    value: GuidedChangeEventStep.ReviewImpact,
    label: "Review Impact",
    isComplete: () => false,
    disabled: () => true,
    render: () => <NotInPrototypeYet />,
  };
}

export function reviewStep<F>(): WorkflowStep<F> {
  return {
    value: GuidedChangeEventStep.Review,
    label: "Review",
    isComplete: () => false,
    disabled: () => true,
    render: () => <NotInPrototypeYet />,
  };
}
